import type { MessageInstanceEventHookScope } from '../index';
import {
	NARROW_EXPOSURE_DROP_REASON,
	type NarrowExposureConfig,
	type NarrowExposureDecision,
	UNEVALUATED_COHORT,
} from './types';

const postedDrops = new Set<string>();

/**
 * Posts a narrow exposure `dropped` event once per message instance, experiment and cohort in the
 * page lifetime, so rerenders, Strict Mode and repeated slot offers post one drop. An early
 * `unevaluated` drop does not block a later drop for the user's real cohort.
 */
export const postNarrowExposureDrop = (
	messageInstanceDropped: MessageInstanceEventHookScope['messageInstanceDropped'],
	messageInstanceId: string | undefined,
	{ statsigExperiment, statsigParameterName }: NarrowExposureConfig,
	decision: Exclude<NarrowExposureDecision, { outcome: 'show' }>,
): void => {
	const cohort = decision.outcome === 'drop' ? decision.cohort : UNEVALUATED_COHORT;

	if (messageInstanceId) {
		const key = `${messageInstanceId}:${statsigExperiment}:${String(cohort)}`;
		if (postedDrops.has(key)) {
			return;
		}
		postedDrops.add(key);
	}

	// A failed drop post must not stop the next queued message being offered.
	messageInstanceDropped({
		dropReason: NARROW_EXPOSURE_DROP_REASON,
		narrowExposureExperiment: { statsigExperiment, statsigParameterName, cohort },
	}).catch(() => undefined);
};
